/** Given a layer key, return all the general layers for that layer key */

import { resolveTopologicalPathForBlock } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../../context/metaModelContext'

export const useGeneralBlocks = (block: Optional<string>) => {
  const { blockTopology } = useMetaModelContext()

  return useMemo(() => {
    if (!block) {
      return []
    }

    return resolveTopologicalPathForBlock(block, blockTopology).slice(0, -1)
  }, [block, blockTopology])
}
